import CKYContainer from "./PrimeCKYCContainer";
import CKYCStore from "./PrimeCKYCStore";

export default CKYCStore(CKYContainer);